import React, { useEffect, useState } from "react";
import { Button, Modal, Form, Spin, Switch } from "antd";
import "@lottiefiles/lottie-player";
import CategoryForm from "../Forms/Category";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
	fetchCategories,
	updateCategory,
	fetchCategory,
} from "../../actions/category";

import "./Category.scss";
import CategoryQuestion from "./categories/CategoryQuestions";
import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";

const CategoryPage = () => {
	const { id } = useParams();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [categoryId, setCategoryId] = useState(null);
	const { categories } = useSelector((state) => state.fetchCategories);
	const { status, category, loading } = useSelector(
		(state) => state.fetchCategory,
	);
	const { categoryUpdated } = useSelector((state) => state.updateCategory);
	const [imagePlayer, setImagePlayer] = useState(null);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = () => {
		dispatch(fetchCategories({}));
		showModal();
		setCategoryId(id);
		const newRecord = { ...category };

		if (category.see_more && category.see_more.length !== 0) {
			const newSeeMore = handleMergeSeeMore(category.see_more);
			newRecord.see_more = newSeeMore;
		}

		form.setFieldsValue(newRecord);
	};

	const handleSubmitForm = (values) => {
		// const newSeeMore = handleSeeMore(values.see_more);
		dispatch(updateCategory(categoryId, values));
		handleOk();
	};

	// const handleSeeMore = (values) => {
	// 	let newValues = [];
	// 	values.map((value) => {
	// 		let splitValue = value.split("|");
	// 		newValues = [
	// 			...newValues,
	// 			{ name: splitValue[1], survey_category_id: parseInt(splitValue[0]) },
	// 		];
	// 	});
	// 	return newValues;
	// };

	const handleMergeSeeMore = (seeMoreArray) => {
		let newValue = [];
		seeMoreArray.map((seeMore) => {
			const newSeeMore = `${seeMore.survey_category_id}|${seeMore.name}`;
			newValue = [...newValue, newSeeMore];
		});

		return newValue;
	};

	useEffect(() => {
		dispatch(fetchCategory(id));
	}, []);

	useEffect(() => {
		const player = document.querySelector("lottie-player");
		if (status === "SUCCEEDED") {
			setImagePlayer(player);
		}
	}, [status]);

	useEffect(() => {
		if (imagePlayer && category) {
			imagePlayer.load(category.image);
		}
	}, [imagePlayer, category]);

	useEffect(() => {
		if (categoryUpdated) dispatch(fetchCategory(id));
	}, [categoryUpdated]);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div id="category-container">
				<div className="page-header">
					<h2 className="page-header-title">Survey Category Details</h2>
				</div>
				<div className="page-header-details-actions">
					<Link to="/survey-categories">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
				</div>
				{status === "SUCCEEDED" && (
					<div className="page-content">
						<div className="page-details-section">
							<div>
								<div className="box">
									<div className="box-header">
										<h2 className="box-title">Details</h2>
									</div>
									<div className="box-content">
										<div className="details-item">
											<label>Name</label>
											<div className="text">{category.name}</div>
										</div>
										<div className="details-item">
											<label>Short Name</label>
											<div className="text">{category.short_name}</div>
										</div>
										<div className="details-item">
											<label>Description</label>
											<div
												className="text"
												dangerouslySetInnerHTML={{
													__html: category.description,
												}}
											></div>
										</div>
										<div className="details-item">
											<label>Informative Text</label>
											<div
												className="text"
												dangerouslySetInnerHTML={{
													__html: category.informative_text,
												}}
											></div>
										</div>
										{/* <div className="details-item">
											<label>See more</label>
											<div className="text">
												{category.see_more &&
													category.see_more.length !== 0 &&
													category.see_more.map((item) => item.name).join(", ")}
											</div>
										</div> */}
										<div className="details-item">
											<label>Topics</label>
											<div className="text">
												{category.topics &&
													category.topics.length !== 0 &&
													category.topics.map((item) => item.name).join(", ")}
											</div>
										</div>
										<div className="details-item">
											<label>Published</label>
											<div className="text">
												<Switch defaultChecked={category.published} />
											</div>
										</div>
										<div className="details-item">
											<label>Disclaimer</label>
											<div className="text">{category.disclaimer}</div>
										</div>
									</div>
								</div>
							</div>
							<div>
								<div className="box">
									<div className="box-header">
										<h2 className="box-title">Image</h2>
									</div>
									<div className="box-content">
										<lottie-player
											controls
											mode="normal"
											style={{ width: "100%" }}
										></lottie-player>
									</div>
								</div>
							</div>
						</div>
						{category.questions && (
							<CategoryQuestion questions={category.questions} />
						)}
					</div>
				)}
				<Modal
					className="add-category-modal"
					visible={isModalVisible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					{categories && (
						<CategoryForm
							form={form}
							categories={categories.data.data}
							categoryId={categoryId}
							handleOk={handleOk}
							handleSubmitForm={handleSubmitForm}
							handleCancel={handleCancel}
						/>
					)}
				</Modal>
			</div>
		</Spin>
	);
};

export default CategoryPage;
